import axiosProtected from "../../../../api/config/baseWithToken";

// Affiliates: customers are linked to an affiliate by an admin.
export const fetchOverview = () => axiosProtected.get("/admin/referrals/overview").then(({ data }) => data.affiliates || []);

export const fetchCustomers = (id) => axiosProtected.get(`/admin/referrals/${id}/customers`).then(({ data }) => data);

export const searchCustomers = (text) =>
  axiosProtected.get("/admin/referrals/customers/search", { params: { text } }).then(({ data }) => data.customers || []);

export const assignCustomer = (userId, affiliateId) =>
  axiosProtected.put("/admin/referrals/assign", { userId, affiliateId });

export const saveAffiliate = (affiliate) =>
  affiliate._id
    ? axiosProtected.put(`/admin/referrals/${affiliate._id}`, { name: affiliate.name, email: affiliate.email })
    : axiosProtected.post("/admin/referrals", { name: affiliate.name, email: affiliate.email });

export const deleteAffiliate = (id) => axiosProtected.delete(`/admin/referrals/${id}`);

export const errorText = (err, fallback) => err?.response?.data?.message || fallback;

export const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "–";

// New partner page link and password; the old ones stop working.
export const createPartnerLink = (id) =>
  axiosProtected.post(`/admin/referrals/${id}/partner-link`).then(({ data }) => data);

export const partnerUrl = (token) => `${window.location.origin}/partner/${token}`;
